import React = require('react');
import { FaInfoCircle } from 'react-icons/fa';

interface Info {
  text: any;
  color?: 'blue' | 'green'
}

export const Info = ({ text, color = 'blue' }: Info) => {

  const icon = color === 'green' ?
    <img width={'20px'} style={{ marginBottom: '5px' }} src={require('../../img/green-circle-ticked.svg')}
         alt={'Admiral'}/> : <FaInfoCircle className="info-btn info-icon"/>;
  return (
    <div>
      <div className={'info-bar-container ' + color}>
        <div className={'content'}>
          <div>{icon}</div>
          <div className={'text ' + color} style={{ marginLeft: '5px', fontSize: '1.5rem' }}>{text}</div>
        </div>
      </div>
    </div>
  )
}
